import React from 'react';
import {AccentedSvgIcon, AccentedSvgIconProps} from './AccentedSvgIcon';
import styled from 'styled-components';

const Styled = styled.div`
    display: flex;
    .ue-icon-arrow-left-alt {
        transform: rotate(180deg);
    }
`;

export const ArrowLeftAlt = (props: AccentedSvgIconProps): JSX.Element => (
    <Styled>
        <AccentedSvgIcon {...props} viewBox="0 0 27 17" className="ue-icon-arrow-left-alt arrow">
            <path
                d="M18.6978 0.932769C18.57 1.06029 18.509 1.2319 18.5034 1.39449C18.4977 1.55716 18.5469 1.73401 18.6701 1.87011L18.6706 1.87061L24.0988 7.83247H1.40323C1.03479 7.83247 0.75 8.13873 0.75 8.49913C0.75 8.85954 1.03479 9.1658 1.40323 9.1658H24.0988L18.6706 15.1276L18.6702 15.1281C18.5472 15.2638 18.4972 15.4409 18.5024 15.604C18.5076 15.767 18.5687 15.9407 18.7006 16.0682C18.9562 16.3154 19.3635 16.3138 19.6269 16.0433L19.627 16.0434L19.6327 16.0372L26.0844 8.95399L26.0905 8.94729L26.0961 8.94018C26.3323 8.63975 26.2688 8.27051 26.0935 8.0549L26.0938 8.05466L26.0844 8.04428L19.6327 0.960994L19.6327 0.960988L19.6312 0.959352C19.3804 0.688956 18.9503 0.680881 18.6978 0.932769ZM18.6978 0.932769L18.8744 1.10976M18.6978 0.932769C18.6978 0.932776 18.6978 0.932783 18.6978 0.93279L18.8744 1.10976M18.8744 1.10976C19.0248 0.959717 19.2917 0.960924 19.4478 1.12934M18.8744 1.10976C18.7216 1.26221 18.7104 1.54209 18.8555 1.7023L24.4369 7.83247L19.4478 1.12934M19.4478 1.12934L25.8995 8.21263L19.4478 1.12934Z"
                strokeWidth="0.5"
            />
        </AccentedSvgIcon>
    </Styled>
);
